import { useMemo } from 'react';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useCurrentConversationValue } from 'hooks/business/conversation';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import { TradeDetailAmountBlock, TradeDetailAmountVariant } from './tradeDetailBlockTypes';

export interface UseTradeAmountBlocksResult {
  paymentAmount?: TradeDetailAmountBlock;
  incomeAmount?: TradeDetailAmountBlock;
}

export const useTradeAmountBlocks = (
  trade: Conversation.Trade.TradeWithLogistics,
): UseTradeAmountBlocksResult => {
  const conversation = useCurrentConversationValue();
  const displaySensitive = useGetPermission()('订单敏感信息');
  const channel = conversation?.channel;

  return useMemo(() => {
    if (!displaySensitive) {
      return {};
    }

    const { totalAmount, payment, customTradeIncome } = trade;
    let paymentVariant: TradeDetailAmountVariant | null = null;
    let incomeVariant: TradeDetailAmountVariant | null = null;

    if (totalAmount && channel === 'LAZADA') {
      paymentVariant = 'payment_lazada';
    }

    if (customTradeIncome?.length > 0 && channel === 'LAZADA') {
      incomeVariant = 'income_lazada';
    }

    if (payment && isTiKTokUpperCase(channel)) {
      paymentVariant = 'payment_tiktok';
    }

    if (channel === 'JOLECT') {
      paymentVariant = 'payment_jolect';
    }

    if (channel === 'KWAI') {
      incomeVariant = 'income_kwai';
    }

    if (payment && channel === 'SHOPEE') {
      incomeVariant = 'income_shopee';
    }

    if (channel === 'MERCADO') {
      incomeVariant = 'income_mercado';
    }

    const blocks: UseTradeAmountBlocksResult = {};

    if (paymentVariant) {
      blocks.paymentAmount = {
        id: 'paymentAmount',
        type: 'amount',
        variant: paymentVariant,
      };
    }

    if (incomeVariant) {
      blocks.incomeAmount = {
        id: 'incomeAmount',
        type: 'amount',
        variant: incomeVariant,
      };
    }

    return blocks;
  }, [trade, displaySensitive, channel]);
};
